<!-- Store Dashboard Container -->
<div class="container-fluid py-4 px-3 d-flex flex-column gap-5">

    <!-- Top Row: Featured Membership Subscriptions (Supporter $20 & VIP $50) -->
    <div class="row g-4 align-items-stretch">

        <!-- Supporter Tier Card ($20/yr) -->
        <div class="col-12 col-md-6 d-flex">
            <div class="card bg-dark border-0 rounded-4 p-4 flex-grow-1 d-flex flex-column justify-content-between position-relative overflow-hidden"
                style="--bs-bg-opacity: 0.5; min-height: 240px; border-left: 3px solid #00d2ff !important;">
                <div>
                    <div class="d-flex justify-content-between align-items-start mb-3">
                        <span class="badge text-uppercase tracking-widest px-2.5 py-1.5 small fw-bold"
                            style="background-color: rgba(0, 210, 255, 0.1); color: #00d2ff; border: 1px solid rgba(0, 210, 255, 0.2);">
                            SUPPORTER TIER
                        </span>
                        <i class="bi bi-shield-check text-info fs-4"></i>
                    </div>
                    <h4 class="fw-extrabold text-uppercase text-white mb-2">Supporter Membership</h4>
                    <p class="text-secondary small mb-3">
                        Priority matchmaking queue, custom username chat colors, supporter profile badge, and
                        high-quality voice channels.
                    </p>
                </div>
                <div class="d-flex align-items-center justify-content-between pt-3 border-top border-secondary">
                    <div>
                        <span class="fs-3 fw-extrabold text-white">$20.00</span>
                        <span class="text-secondary small">/ year</span>
                    </div>
                    <button class="btn btn-subscribe px-4 py-2.5 text-uppercase tracking-wider small fw-bold"
                        (click)="openCheckout({ id: 'prod_V0ngRwyzWNjbou', priceId: 'price_1U0q7fCIybDFDaGtdyrA4yh5', name: 'Supporter Tier Membership', price: 20.00, description: '1-Year Supporter Membership', isSubscription: true, planTier: 'Supporter', imageUrl: 'images/featured/elite_subscription.png' })">
                        Subscribe $20
                    </button>
                </div>
            </div>
        </div>

        <!-- VIP Tier Card ($50/yr) -->
        <div class="col-12 col-md-6 d-flex">
            <div class="card bg-dark border-0 rounded-4 p-4 flex-grow-1 d-flex flex-column justify-content-between position-relative overflow-hidden"
                style="--bs-bg-opacity: 0.5; min-height: 240px; border-left: 3px solid #ffc107 !important;">
                <div>
                    <div class="d-flex justify-content-between align-items-start mb-3">
                        <span class="badge text-uppercase tracking-widest px-2.5 py-1.5 small fw-bold"
                            style="background-color: rgba(255, 193, 7, 0.15); color: #ffc107; border: 1px solid rgba(255, 193, 7, 0.3);">
                            VIP ULTIMATE
                        </span>
                        <i class="bi bi-crown text-warning fs-4"></i>
                    </div>
                    <h4 class="fw-extrabold text-uppercase text-white mb-2">VIP Membership</h4>
                    <p class="text-secondary small mb-3">
                        All Supporter perks + exclusive VIP Gold Nameplate, VIP glow effect, and premier lobby status.
                    </p>
                </div>
                <div class="d-flex align-items-center justify-content-between pt-3 border-top border-secondary">
                    <div>
                        <span class="fs-3 fw-extrabold text-white">$50.00</span>
                        <span class="text-secondary small">/ year</span>
                    </div>
                    <button class="btn btn-subscribe px-4 py-2.5 text-uppercase tracking-wider small fw-bold"
                        style="background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%); color: #000;"
                        (click)="openCheckout({ id: 'sub-vip-yearly', priceId: 'price_1U17L7CIybDFDaGtKfkAAANk', name: 'VIP Membership', price: 50.00, description: '1-Year VIP Membership', isSubscription: true, planTier: 'VIP', imageUrl: 'images/name-plates/gold-nameplate.png' })">
                        Subscribe $50
                    </button>
                </div>
            </div>
        </div>

    </div>

    <!-- Bottom Row: Categorized, Searchable Catalog -->
    <div class="row g-4">

        <!-- Search and Filter Toolbar -->
        <div class="col-12 d-flex flex-wrap align-items-center justify-content-between gap-3 pb-3">
            <div class="search-wrapper position-relative" style="width: 280px; max-width: 100%;">
                <i class="bi bi-search position-absolute start-0 top-50 translate-middle-y ms-3 text-secondary"></i>
                <input type="text" class="form-control bg-black border border-secondary text-white py-2 ps-5 pe-3"
                    style="--bs-bg-opacity: 0.25; font-size: 0.9rem;" placeholder="Search shop..."
                    [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)">
            </div>

            <ul class="nav nav-pills gap-2">
                @for(cat of categories(); track cat) {
                <li class="nav-item">
                    <button class="btn btn-category" [class.active]="selectedCategory() === cat"
                        (click)="selectCategory(cat)">
                        {{ cat }}
                    </button>
                </li>
                }
            </ul>
        </div>

        <!-- Catalog Grid -->
        @if (filteredCatalogItems().length > 0) {
        @for(item of filteredCatalogItems(); track item.id) {
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="card bg-dark border border-secondary rounded-4 overflow-hidden h-100 d-flex flex-column justify-content-between"
                style="--bs-bg-opacity: 0.4;">

                <!-- Image Wrapper with Bottom Glow -->
                <div class="position-relative overflow-hidden d-flex align-items-center justify-content-center p-3"
                    style="aspect-ratio: 16 / 9; background: radial-gradient(circle at center, #181822 0%, #09090d 100%);">
                    <img [src]="item.imageUrl" class="mw-100 mh-100 object-fit-contain" [alt]="item.name"
                        loading="lazy">
                    @if (isOwnedItem(item)) {
                    <span
                        class="position-absolute top-0 end-0 m-3 badge text-uppercase tracking-wider px-2 py-1 shadow bg-success">
                        <i class="bi bi-check-circle-fill me-1"></i> OWNED
                    </span>
                    } @else if (item.badge) {
                    <span
                        class="position-absolute top-0 start-0 m-3 badge text-uppercase tracking-wider px-2 py-1 shadow"
                        style="background-color: #e84057; color: #fff;">{{ item.badge }}</span>
                    }
                    <!-- Bottom Rarity Bar -->
                    <div class="position-absolute bottom-0 start-0 w-100" style="height: 3px;"
                        [class]="getRarityClass(item.rarity)"></div>
                </div>

                <!-- Info & Pricing -->
                <div class="card-body p-4 d-flex flex-column justify-content-between flex-grow-1">
                    <div>
                        <span class="text-uppercase tracking-widest small fw-bold mb-1 d-block"
                            [class]="getRarityClass(item.rarity)">
                            {{ item.rarity }}
                        </span>
                        <h6 class="fw-bold text-white mb-2 text-truncate" [title]="item.name">{{ item.name }}</h6>
                        <p class="text-secondary small mb-4 font-light-height" style="min-height: 40px;">{{
                            item.description }}</p>
                    </div>

                    <div class="d-flex align-items-center justify-content-between pt-3 border-top border-secondary">
                        <span class="fw-extrabold text-white">
                            @if (item.price === 0) {
                            FREE (Achievement)
                            } @else {
                            ${{ item.price.toFixed(2) }}@if (item.isSubscription) {/yr}
                            }
                        </span>
                        @if (isOwnedItem(item)) {
                        <button class="btn btn-sm btn-outline-success text-uppercase tracking-wider px-3 py-1.5 fw-bold"
                            disabled>
                            Owned
                        </button>
                        } @else {
                        <button class="btn btn-sm text-uppercase tracking-wider px-3 py-1.5 fw-bold"
                            [class.btn-subscribe]="item.isSubscription"
                            [class.btn-purchase-bundle]="!item.isSubscription" (click)="openCheckout(item)">
                            {{ item.isSubscription ? 'Subscribe' : (item.price === 0 ? 'Claim' : 'Buy') }}
                        </button>
                        }
                    </div>
                </div>

            </div>
        </div>
        }
        }
        @else {
        <div class="col-12 text-center py-5">
            <i class="bi bi-search fs-1 text-secondary mb-3 d-block"></i>
            <h5 class="fw-bold text-white">No items found</h5>
            <p class="text-secondary small mb-0">Try search queries matching other names or categories.</p>
        </div>
        }

    </div>

</div>

<!-- Checkout Modal Component -->
<app-checkout-modal *ngIf="checkoutItem()" [item]="checkoutItem()" (close)="closeCheckout()"
    (purchaseSuccess)="handlePurchaseSuccess($event)">
</app-checkout-modal>

<!-- Loot Chest Opening Modal Component -->
@if (unlockedReward(); as rewardObj) {
<app-loot-opening-modal [reward]="rewardObj" (close)="closeLootOpening()">
</app-loot-opening-modal>
}